import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { h2 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Grid = styled.div `
  ${baseGrid};
`;
const Title = styled.h2 `
  ${h2};
  grid-column: span 12;

  @media ${from(Device.Tablet)} {
    grid-column: 2 / span 10;
  }
`;
const CardList = styled.div `
  grid-column: span 12;

  @media ${from(Device.Tablet)} {
    grid-column: 3 / span 8;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: 4 / span 6;
  }
`;
const DownloadsStyles = {
    CardList,
    Container,
    Grid,
    Title,
};
export default DownloadsStyles;
